namespace Portico.Services {
    import Inject = Portico.Decorators.Inject;
	import Service = Portico.Decorators.Service;
    import psga = apigateway.client;
    import psgm = apigateway.models;

    export interface IPayloadStagingService {
        StagePayload: (request: psgm.StagePayloadRequest) => angular.IPromise<psgm.PayloadStagingV1PayloadStagePayloadStagePayloadResponse>
    }

    @Service('app', 'payloadStagingService')
    @Inject('$q', 'EdgePayloadStagingApi')
    export class PayloadStagingService implements IPayloadStagingService {
		constructor(
            private $q: angular.IQService,
            private payloadStagingApi: psga.EdgePayloadStagingApi
        ){}

        StagePayload(request: psgm.StagePayloadRequest) {
            return this.$q.when(this.payloadStagingApi.payloadStagePayload(request).then(response => {
                return response.data;
            }));
        }
    }
}